import { useState } from "react";
import deleteDocumentbyID from "../../firestore/deleteDocumentByID";

const useDeleteDocument = (collection: string) => {
  const [deleteFlag, setDeleteFlag] = useState<boolean>(false);
  //   const [createdChapter, setCreatedChapter] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const deleteChapter = async (docId: any) => {
    try {
      setLoading(true);
      await deleteDocumentbyID(collection, docId);
      setDeleteFlag((prev) => !prev);
      console.log("Deleted: " + docId + " from collection: " + collection);
    } catch (error) {
      console.log("Error creating chapter");
    } finally {
      setLoading(false);
    }
    return docId;
  };

  return { deleteFlag, deleteChapter, loading };
};

export default useDeleteDocument;
